<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button
        [attr.data-action]="'clicked-back-from-crm-field-management'"
        [useHistory]="true"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'OBJECT_TYPES.CUSTOM_FIELDS' | translate }}</glxy-page-title>
  </glxy-page-toolbar>
  <crm-drawer #drawer>
    <crm-vertical-nav-tab [useQueryParams]="false" class="side-nav" (tabClicked)="tabClicked($event)">
      <crm-vertical-nav-card [label]="'Contacts'">
        <div class="actions-container">
          <a class="action" mat-raised-button color="primary" (click)="createDrawer()">
            {{ 'ACTIONS.CREATE' | translate }}
          </a>
        </div>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
          <mat-tab label="Fields">
            <crm-list-custom-fields
              [objType]="'Contact'"
              (editField)="editDrawer($event)"
              (deleteField)="confirmDelete($event)"
            ></crm-list-custom-fields>
          </mat-tab>
        </mat-tab-group>
      </crm-vertical-nav-card>
      <crm-vertical-nav-card [label]="'Companies'">
        <div class="actions-container">
          <a class="action" mat-raised-button color="primary" (click)="createDrawer()">
            {{ 'ACTIONS.CREATE' | translate }}
          </a>
        </div>
        <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
          <mat-tab label="Fields">
            <crm-list-custom-fields
              [objType]="'Company'"
              (editField)="editDrawer($event)"
              (deleteField)="confirmDelete($event)"
            ></crm-list-custom-fields>
          </mat-tab>
        </mat-tab-group>
      </crm-vertical-nav-card>
      @for (nav of extraNavs(); track nav) {
        <crm-vertical-nav-card [label]="nav.label">
          @if ((nav.label | dasherize) === currentTabClicked()) {
            <ng-container *ngComponentOutlet="nav.component; inputs: nav.inputs" />
          }
        </crm-vertical-nav-card>
      }
    </crm-vertical-nav-tab>
  </crm-drawer>
</glxy-page>

<ng-template #upsert>
  <div class="drawer-container">
    @if (isSystemField()) {
      <div class="alert">
        <glxy-alert type="tip">
          {{ 'CUSTOM_FIELDS.SYSTEM_FIELDS_MESSAGE' | translate }}
        </glxy-alert>
      </div>
    }
    <form [formGroup]="formGroup" novalidate #form="ngForm" class="drawer">
      <glxy-form-row>
        <glxy-form-field bottomSpacing="small" [showLabel]="true" [required]="true">
          <glxy-label>{{ 'CUSTOM_FIELDS.OBJECT' | translate }}</glxy-label>
          <mat-select #defaultInput formControlName="objectType" [placeholder]="'CUSTOM_FIELDS.OBJECT' | translate">
            <mat-option value="Contact">{{ 'OBJECT_TYPES.CONTACT' | translate }}</mat-option>
            <mat-option value="Company">{{ 'OBJECT_TYPES.COMPANY' | translate }}</mat-option>
          </mat-select>
        </glxy-form-field>
      </glxy-form-row>
      <glxy-form-row>
        <glxy-form-field bottomSpacing="small" [showLabel]="true" [required]="true">
          <glxy-label>{{ 'CUSTOM_FIELDS.FIELD_NAME' | translate }}</glxy-label>
          <input formControlName="fieldName" matInput placeholder="{{ 'CUSTOM_FIELDS.FIELD_NAME' | translate }}" />
          @if (formGroup.get('fieldName').touched && formGroup.get('fieldName').hasError('required')) {
            <glxy-error>
              {{ 'CUSTOM_FIELDS.ERROR.FIELD_NAME_REQUIRED' | translate }}
            </glxy-error>
          }
        </glxy-form-field>
      </glxy-form-row>
      <crm-external-id
        [fieldId]="editObjectId()"
        [externalId]="formGroup.value?.externalId ?? ''"
        [name]="formGroup.value?.fieldName ?? ''"
        [objectType]="formGroup.controls['objectType'].value"
        [createNewField]="action() === 'create'"
        [disabled]="isEditingDisabled()"
        (externalIdChange)="externalIdChanged($event)"
        (externalIdErrors)="externalIdErrorsChanged($event)"
      ></crm-external-id>
      <glxy-form-row>
        <glxy-form-field bottomSpacing="small" [showLabel]="true">
          <glxy-label>{{ 'CUSTOM_FIELDS.FIELD_DESCRIPTION' | translate }}</glxy-label>
          <textarea
            formControlName="fieldDescription"
            matInput
            placeholder="{{ 'CUSTOM_FIELDS.FIELD_DESCRIPTION' | translate }}"
          ></textarea>
        </glxy-form-field>
      </glxy-form-row>

      <glxy-form-field bottomSpacing="small" [showLabel]="true" [required]="true">
        <glxy-label>{{ 'CUSTOM_FIELDS.FIELD_TYPE' | translate }}</glxy-label>
        <mat-select formControlName="fieldType" placeholder="{{ 'CUSTOM_FIELDS.FIELD_TYPE' | translate }}">
          @for (fieldType of fieldTypes; track fieldType.fieldType) {
            @if (fieldType.label && fieldType.fieldType) {
              <mat-option [value]="fieldType.fieldType">
                {{ fieldType.label | translate }}
                @if (fieldType.example) {
                  ({{ fieldType.example | translate }})
                }
              </mat-option>
            }
          }
        </mat-select>
        @if (formGroup.get('fieldType').touched && formGroup.get('fieldType').hasError('required')) {
          <glxy-error>
            {{ 'CUSTOM_FIELDS.ERROR.FIELD_TYPE_REQUIRED' | translate }}
          </glxy-error>
        }
      </glxy-form-field>
    </form>
    @if (action() === 'create') {
      <div class="drawer-actions">
        <button mat-flat-button color="primary" type="button" (click)="createField()">
          {{ 'ACTIONS.CREATE' | translate }}
        </button>
      </div>
    }
    @if (action() === 'edit' && !isSystemField()) {
      <div class="drawer-actions">
        <button mat-flat-button color="primary" type="button" (click)="editField()">
          {{ 'ACTIONS.SAVE' | translate }}
        </button>
      </div>
    }
  </div>
</ng-template>
